// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");
var Browser__Tabs$SmartcutsMacros = require("./Browser__Tabs.bs.js");

function sendMessageToExtension(message) {
  return new Promise((function (resolve, reject) {
                chrome.runtime.sendMessage(message, (function (maybeResponse) {
                        if (maybeResponse !== undefined) {
                          var jsonResponse = Caml_option.valFromOption(maybeResponse);
                          var match = Js_json.decodeString(jsonResponse);
                          if (match === "ignored_msg_not_from_extension") {
                            return ;
                          } else {
                            return resolve(jsonResponse);
                          }
                        }
                        var jsExn = browser.runtime.lastError;
                        if (jsExn == null) {
                          return resolve(null);
                        } else {
                          return reject(Js_exn.raiseError(OptionUtils$SmartcutsMacros.withDefault("", jsExn.message)));
                        }
                      }));
                
              }));
}

var AsJs = {};

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.optionToJson(Decco.stringToJson, v.id)
              ],
              [
                "frameId",
                Decco.optionToJson(Decco.intToJson, v.frameId)
              ],
              [
                "tab",
                Decco.optionToJson(Browser__Tabs$SmartcutsMacros.Tab.t_encode, v.tab)
              ],
              [
                "url",
                Decco.optionToJson(Decco.stringToJson, v.url)
              ],
              [
                "nativeApplication",
                Decco.optionToJson(Decco.stringToJson, v.nativeApplication)
              ],
              [
                "tlsChannelId",
                Decco.optionToJson(Decco.stringToJson, v.tlsChannelId)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var frameId = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "frameId"), null));
    if (frameId.TAG === /* Ok */0) {
      var tab = Decco.optionFromJson(Browser__Tabs$SmartcutsMacros.Tab.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tab"), null));
      if (tab.TAG === /* Ok */0) {
        var url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */0) {
          var nativeApplication = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "nativeApplication"), null));
          if (nativeApplication.TAG === /* Ok */0) {
            var tlsChannelId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tlsChannelId"), null));
            if (tlsChannelId.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        id: id._0,
                        frameId: frameId._0,
                        tab: tab._0,
                        url: url._0,
                        nativeApplication: nativeApplication._0,
                        tlsChannelId: tlsChannelId._0
                      }
                    };
            }
            var e = tlsChannelId._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".tlsChannelId" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = nativeApplication._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".nativeApplication" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = url._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".url" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = tab._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".tab" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = frameId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".frameId" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function fromJs(senderJs) {
  return {
          id: Caml_option.undefined_to_opt(senderJs.id),
          frameId: Caml_option.undefined_to_opt(senderJs.frameId),
          tab: OptionUtils$SmartcutsMacros.map(Caml_option.undefined_to_opt(senderJs.tab), Browser__Tabs$SmartcutsMacros.Tab.fromJs),
          url: Caml_option.undefined_to_opt(senderJs.url),
          nativeApplication: Caml_option.undefined_to_opt(senderJs.nativeApplication),
          tlsChannelId: Caml_option.undefined_to_opt(senderJs.tlsChannelId)
        };
}

function stringify(param) {
  return "sender(tabId=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(OptionUtils$SmartcutsMacros.andThen((function (tab) {
                          return tab.id;
                        }), param.tab), (function (prim) {
                      return String(prim);
                    }))) + (", frameId=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.map(param.frameId, (function (prim) {
                          return String(prim);
                        }))) + ")")));
}

function isTabId(tabId, sender) {
  return OptionUtils$SmartcutsMacros.equalsSome(tabId, Belt_Option.flatMap(sender.tab, (function (tab) {
                    return tab.id;
                  })));
}

var Sender = {
  AsJs: AsJs,
  t_encode: t_encode,
  t_decode: t_decode,
  fromJs: fromJs,
  stringify: stringify,
  isTabId: isTabId
};

var OnMessage = {};

function addListener(listener) {
  browser.runtime.onMessage.addListener(function (jsonMessage, senderAsJs, sendResponse) {
        var sender = fromJs(senderAsJs);
        var _tab = sender.tab;
        if (_tab !== undefined) {
          return false;
        } else {
          Curry._1(listener, jsonMessage).then(Curry.__1(sendResponse));
          return true;
        }
      });
  
}

var OnMessageFromExtension = {
  addListener: addListener
};

var OnMessageToExtension = {};

var OnMessageExternal = {};

var _map = {"install":"install","update":"update","chrome_update":"chrome_update","shared_module_update":"shared_module_update"};

function tToJs(param) {
  return param;
}

function tFromJs(param) {
  return _map[param];
}

function stringify$1(v) {
  if (v === "shared_module_update") {
    return "shared_module_update";
  } else if (v === "update") {
    return "update";
  } else if (v === "install") {
    return "install";
  } else {
    return "chrome_update";
  }
}

var t_encode$1 = stringify$1;

function t_decode$1(encoded) {
  var str = Js_json.decodeString(encoded);
  if (str === undefined) {
    return Decco.error(undefined, "Couldn't decode json into OnInstalledReason", encoded);
  }
  switch (str) {
    case "chrome_update" :
        return {
                TAG: /* Ok */0,
                _0: "chrome_update"
              };
    case "install" :
        return {
                TAG: /* Ok */0,
                _0: "install"
              };
    case "shared_module_update" :
        return {
                TAG: /* Ok */0,
                _0: "shared_module_update"
              };
    case "update" :
        return {
                TAG: /* Ok */0,
                _0: "update"
              };
    default:
      return Decco.error(undefined, "Expected valid json string for onInstalled reason, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
  }
}

var OnInstalledReason = {
  tToJs: tToJs,
  tFromJs: tFromJs,
  stringify: stringify$1,
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

var Details = {};

var External = {
  Details: Details
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "reason",
                stringify$1(v.reason)
              ],
              [
                "previousVersion",
                Decco.optionToJson(Decco.stringToJson, v.previousVersion)
              ],
              [
                "id",
                Decco.optionToJson(Decco.stringToJson, v.id)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var reason = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "reason"), null));
  if (reason.TAG === /* Ok */0) {
    var previousVersion = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "previousVersion"), null));
    if (previousVersion.TAG === /* Ok */0) {
      var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
      if (id.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  reason: reason._0,
                  previousVersion: previousVersion._0,
                  id: id._0
                }
              };
      }
      var e = id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".id" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = previousVersion._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".previousVersion" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = reason._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".reason" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromExternal(param) {
  var arg = _map[param.reason];
  return {
          reason: (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
              })("Expected a valid browser.runtime.onInstalled details"),
          previousVersion: param.previousVersion,
          id: param.id
        };
}

function stringify$2(param) {
  return "{id: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.id) + (", previousVersion: " + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.previousVersion) + (", reason: " + (stringify$1(param.reason) + "}")))));
}

var Details$1 = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromExternal: fromExternal,
  stringify: stringify$2
};

function addListener$1(onDetails) {
  browser.runtime.onInstalled.addListener(function (externalDetails) {
        return Curry._1(onDetails, fromExternal(externalDetails));
      });
  
}

var OnInstalled = {
  OnInstalledReason: OnInstalledReason,
  External: External,
  Details: Details$1,
  addListener: addListener$1
};

var Manifest = {};

function toKeyInput(k) {
  if (k) {
    return "Meta";
  } else {
    return "Control";
  }
}

var DefaultShortcutKey = {
  toKeyInput: toKeyInput
};

function platformOs_encode(v) {
  switch (v) {
    case /* Mac */0 :
        return ["Mac"];
    case /* Win */1 :
        return ["Win"];
    case /* Android */2 :
        return ["Android"];
    case /* Cros */3 :
        return ["Cros"];
    case /* Linux */4 :
        return ["Linux"];
    case /* Openbsd */5 :
        return ["Openbsd"];
    
  }
}

function platformOs_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Android" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Android */2
                  };
          }
      case "Cros" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Cros */3
                  };
          }
      case "Linux" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Linux */4
                  };
          }
      case "Mac" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Mac */0
                  };
          }
      case "Openbsd" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Openbsd */5
                  };
          }
      case "Win" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Win */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function platformOsToJs(platformOs) {
  switch (platformOs) {
    case /* Mac */0 :
        return "mac";
    case /* Win */1 :
        return "win";
    case /* Android */2 :
        return "android";
    case /* Cros */3 :
        return "cros";
    case /* Linux */4 :
        return "linux";
    case /* Openbsd */5 :
        return "openbsd";
    
  }
}

function platformOsFromJs(s) {
  switch (s) {
    case "android" :
        return /* Android */2;
    case "cros" :
        return /* Cros */3;
    case "linux" :
        return /* Linux */4;
    case "mac" :
        return /* Mac */0;
    case "openbsd" :
        return /* Openbsd */5;
    case "win" :
        return /* Win */1;
    default:
      return ;
  }
}

var _map$1 = {"arm":"arm","arm64":"arm64","x86_32":"x86-32","x86_64":"x86-64","mips":"mips","mips64":"mips64"};

var _revMap = {"arm":"arm","arm64":"arm64","x86-32":"x86_32","x86-64":"x86_64","mips":"mips","mips64":"mips64"};

function platformArchToJs(param) {
  return _map$1[param];
}

function platformArchFromJs(param) {
  return _revMap[param];
}

var _map$2 = {"arm":"arm","x86_32":"x86-32","x86_64":"x86-64","mips":"mips","mips64":"mips64"};

var _revMap$1 = {"arm":"arm","x86-32":"x86_32","x86-64":"x86_64","mips":"mips","mips64":"mips64"};

function platformNaclArchToJs(param) {
  return _map$2[param];
}

function platformNaclArchFromJs(param) {
  return _revMap$1[param];
}

var External$1 = {};

function fromExternal$1(param) {
  var arg = platformOsFromJs(param.os);
  var arg$1 = _revMap[param.arch];
  var arg$2 = _revMap$1[param.nacl_arch];
  return {
          os: (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg);
              })("Unexpected os value: $os"),
          arch: (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
              })("Unexpected arch value: $arch"),
          nacl_arch: (function (param) {
                return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
              })("Unexpected nacl_arch value: $naclArch")
        };
}

function getDefaultShortcutKey(param) {
  if (param.os !== 0) {
    return /* Ctrl */0;
  } else {
    return /* Cmd */1;
  }
}

var PlatformInfo = {
  platformOs_encode: platformOs_encode,
  platformOs_decode: platformOs_decode,
  platformOsToJs: platformOsToJs,
  platformOsFromJs: platformOsFromJs,
  platformArchToJs: platformArchToJs,
  platformArchFromJs: platformArchFromJs,
  platformNaclArchToJs: platformNaclArchToJs,
  platformNaclArchFromJs: platformNaclArchFromJs,
  External: External$1,
  fromExternal: fromExternal$1,
  getDefaultShortcutKey: getDefaultShortcutKey
};

var GetPlatformInfo = {};

function getPlatformInfo(param) {
  return browser.runtime.getPlatformInfo().then(function (extPlatformInfo) {
              return Promise.resolve(fromExternal$1(extPlatformInfo));
            });
}

exports.sendMessageToExtension = sendMessageToExtension;
exports.Sender = Sender;
exports.OnMessage = OnMessage;
exports.OnMessageFromExtension = OnMessageFromExtension;
exports.OnMessageToExtension = OnMessageToExtension;
exports.OnMessageExternal = OnMessageExternal;
exports.OnInstalled = OnInstalled;
exports.Manifest = Manifest;
exports.DefaultShortcutKey = DefaultShortcutKey;
exports.PlatformInfo = PlatformInfo;
exports.GetPlatformInfo = GetPlatformInfo;
exports.getPlatformInfo = getPlatformInfo;
/* StringUtils-SmartcutsMacros Not a pure module */
